module.exports = __webpack_public_path__ + "img/Kraftrad.8841a5ce.svg";